import { EntitiesStore } from './entities-store.abstract';
import { HttpClient } from '@angular/common/http';
import { PhaseStore } from './phase-store';

export interface IAthleteResults {
  Rnk: number;
  Id: number;
  ComLevel: number;
  ComLevelDescr: string;
  ComDis: number;
  ComDisDescr: string;
  Name: string;
  NameShort: string;
  Country: string;
  CountryName: string;
  Cont: number;
  Cat: string;
  IsTeam: number;
  DFrom: Date;
  DTo: Date;
  QuRnk: number;
  QuScore: number;
  Members?: IMember[];
  Matches: IMatch[];
}

export interface IMatch {
  Phase: number;
  Score: number;
  ScoreOpponent: number;
  WinLose: boolean;
  Athlete: IAthlete;
  PhaseNameShort: string;
  PhaseName: string;
}

export interface IAthlete {
  Id: string;
  Name: string;
  NOC: string;
  Members?: IMember[];
}

export interface IMember {
  Id: string;
  FName: string;
  GName: string;
  WNameOrd: boolean;
}

export class AthleteResultsStore extends EntitiesStore<IAthleteResults> {
  constructor(http: HttpClient) {
    super('ATHLETERESULTS', http, [{ entity: new PhaseStore(http), params: { RBP: 'ALL' } }]);
  }
}
